export const wine_and_book = {
  product_id: "6",
  grid_type: "1",
  cover_image: "/1.jpg",
  product_name: "Wein-Halter",
  media: ["1.jpg", "2.jpg", "3.jpg", "4.jpg"],
  product_price: 69.5,
  product_discount: 0,
  product_slug: "wine-and-book",
  short_description: "Der Wein-Halter vereint stilvolle Funktionalität mit modernem Design. Gefertigt aus hochwertigem Acrylglas mit diamantgeschliffenen Rändern, bietet er eine elegante Möglichkeit, Weinflaschen und Bücher gleichzeitig zu präsentieren – perfekt für Genießer mit Sinn für Ästhetik.",
  description: `
  Mühelose Eleganz für Wein und Bücher
  <br><br>
  Wir stellen unseren Weinhalter vor, ein vielseitiges Meisterwerk, das Ihre Wein- und Bücheraufbewahrung mit müheloser Eleganz aufwertet. Dieser durchdachte Halter verbindet nahtlos die Liebe zu edlem Wein und die Freude am Lesen.
  <br><br>
  Der von unseren erfahrenen Handwerkern handgefertigte und von unseren Architekten entworfene Weinhalter verkörpert die Kunst schlichter Raffinesse. Sein minimalistisches Design macht es möglich, Ihre Weinsammlung aufzuwerten und Ihre Lieblingsbücher unterzubringen, was ihn zu einem wahren Spiegelbild des raffinierten Geschmacks macht. Verwandeln Sie Ihr Weinregal in eine exquisite Auslage, während Ihre geschätzten Bücher in Reichweite bleiben. 
  <br><br>
  Dieser Doppelzweckhalter verleiht Ihrem Raum nicht nur Stil, sondern fördert auch ein kultiviertes Ambiente für diejenigen, die die feinen Dinge des Lebens zu schätzen wissen. Überraschen Sie den Weinkenner oder Bücherliebhaber in Ihrem Leben mit diesem stilvollen Plexiglashalter. Ob zu Geburtstagen, Jubiläen, Einweihungen oder anderen besonderen Anlässen, der „Weinhalter " ist immer eine gute Wahl. Verschönern Sie Ihren Raum mit dieser vielseitigen Kreation und erfreuen Sie sich an der Schönheit des Doppelnutzungsdesigns.
  <br><br>
  <h6> PRODUKTPFLEGE </h6>
  Um das makellose Aussehen Ihres ‘Weinhalters‘ zu erhalten, verwenden Sie ein weiches, trockenes Tuch, um Staub zu entfernen, der sich im Laufe der Zeit ansammeln kann. So sieht Ihr Neujahrsferien-Set am besten aus und behält seine transparente Brillanz
  <br><br>
  Wenn Sie diese Pflegerichtlinien befolgen, können Sie sicherstellen, dass Ihr ‘‘Weinhalters‘‘ weiterhin glänzt und Ihre Inneneinrichtung über Jahre hinweg bereichert.
  `,
  specifications: {
    rows: [
      { name: "Material", value: "Hochwertiges Acrylglas" },
      { name: "Abmessungen", value: "54cm x 20cm x 6cm" },
      { name: "Gewicht", value: "1477 Gramm" },
      { name: "Farbe", value: "Transparent" },
      { name: "Ränder", value: "Diamantgeschliffen" },
    ],
    description: `Diese Angaben unterstreichen die Premium-Qualität und den Präzisionsgrad Ihres "Weinhalter"-Produkts, Sie machen potenziellen Kunden deutlich, was sie in Bezug auf Material, Größe, Gewicht, Farbe und Ausführung erwarten können.
    `,
  },
  category: "Table",
  title_color: "#ffffff",
  subtitle_color: "#999999",
  price_color: "#ffffff"
};
